const useLinkUploadError = () => {
    const API_NO_YTDLP_DATA_INFO_KEY = "API_NO_YTDLP_DATA_INFO"; // 链接错误信息-本地存储的键名
    const API_LIMITED_INFO_KEY = "API_LIMITED_INFO"; // api限制信息-本地存储的键名

    /**
     * 根据具体情况，保存对应的信息到localStorage中
     * @param link 链接
     * @param errorMessage 错误信息
     * @param restrictRequest 是否需要限制api请求
     */
    const saveLinkErrorInfo = (link, errorMessage, restrictRequest = false) => {
        if (restrictRequest) {
            // 保存api限制信息
            const apiLimitedInfo = {
                datetime: Date.now() + 24 * 60 * 60 * 1000,
                message: errorMessage,
            };
            localStorage.setItem(API_LIMITED_INFO_KEY, JSON.stringify(apiLimitedInfo));
        } else {
            // 保存链接错误信息
            const apiNoYtDlpDataInfo = {
                link,
                errorMessage,
                recordedTime: Date.now() + 60 * 1000,
            };
            localStorage.setItem(API_NO_YTDLP_DATA_INFO_KEY, JSON.stringify(apiNoYtDlpDataInfo));
        }
    };

    /**
     * 校验是否可用
     * @param link 链接
     * @returns
     */
    const getLinkErrorInfo = (link) => {
        const apiLimitedMessage = checkApiLimitedInfo();
        if (apiLimitedMessage !== undefined) {
            return apiLimitedMessage;
        } else {
            return checkApiNoYtDlpDataInfo(link);
        }
    };

    /**
     * 检查api是否可用
     * @returns
     */
    const checkApiLimitedInfo = () => {
        const storedErrorInfo = localStorage.getItem(API_LIMITED_INFO_KEY); // 获取存储的api限制信息
        if (!storedErrorInfo) return undefined; //没有，则api当前可用

        const apiLimitedInfo = JSON.parse(storedErrorInfo); // 解析
        const currentTime = Date.now(); // 获取当前时间
        // 判断api是否可用，如果不可用，则返回错误；可用，删除api限制信息
        if (apiLimitedInfo.datetime >= currentTime) {
            return apiLimitedInfo.message;
        } else {
            localStorage.removeItem(API_LIMITED_INFO_KEY);
            return undefined;
        }
    };

    /**
     *  校验链接是否可用
     * @param link 链接
     * @returns
     */
    const checkApiNoYtDlpDataInfo = (link) => {
        const storedErrorInfo = localStorage.getItem(API_NO_YTDLP_DATA_INFO_KEY); // 获取链接错误信息
        if (!storedErrorInfo) return undefined;

        const apiNoYtDlpDataInfo = JSON.parse(storedErrorInfo); // 解析
        const currentTime = Date.now(); // 获取当前时间

        // 判断链接是否可用，如果不可用，则返回错误；可用，删除链接错误信息
        if (apiNoYtDlpDataInfo.link == link && apiNoYtDlpDataInfo.recordedTime >= currentTime) {
            return apiNoYtDlpDataInfo.errorMessage;
        } else {
            localStorage.removeItem(API_NO_YTDLP_DATA_INFO_KEY);
            return undefined;
        }
    };

    return {
        saveLinkErrorInfo,
        getLinkErrorInfo,
    };
};

export default useLinkUploadError;
